/* eslint-disable */
import axios from 'axios'
// import Cookie from 'js-cookie'
import {
	Message
} from 'element-ui'
// import Session from './ucneter/session'
import account from './ucenter/account.js'
//设置请求baseURL
axios.defaults.baseURL = ''
//设置默认请求头
axios.defaults.headers = {
	"Content-Type": "application/json;charset=UTF-8"
}

// 默认超时时间
axios.defaults.timeout = 30000
// 带cookie请求
axios.defaults.withCredentials = true
axios.interceptors.request.use(function (config) {
	// 发送请求之前做一些处理
	let token = sessionStorage.publicToken;
	if (token) {
		config.headers.Authorization = "Bearer " + token;
		config.headers.responseType = 'arraybuffer';
	}
	return config;
}, function (error) {
	// 当请求异常时做一些处理
	return Promise.reject(error);
});

// 响应时拦截
axios.interceptors.response.use(function (response) {
	// 返回响应时做一些处理
	return response;
}, function (error) {
	// 当响应异常时做一些处理
  let type = 'error'
  let showMsg = true
	switch (error.response.status) {
		case 500:
			error.response.message = '服务发生错误，请检查'
			showMsg = false
			break;
		case 400:
			if(error.response.data.path == "/subject/entp/create"
			|| error.response.data.path == "/subject/gov/create"
			|| error.response.data.path == "/subject/zone/create"
			|| error.response.data.path == "/subject/water/create"
			|| error.response.data.path == "/subject/other/create" ){
				showMsg = false
			}
			error.response.message = error.response.data.message
			break;
		case 401:
			type = 'info'
			error.response.message = '当前登录已经失效，请重新登录'
			account.logout();
			location.reload(`/#/login`)
			break;
		case 403:
			error.response.message = '授权失败，请检查是否超时或无权限'
			break;
		case 404:
			error.response.message = '未找到请求地址'
			break;
		case 301:
			type = 'info'
			error.response.message = '授权失败，请检查是否超时或无权限'
			// location.replace(`/#/login`)
			account.logout();
			location.reload(`/#/login`)
			break;
		case 415:
			error.response.message = '请求参数有误，请检查是否正确'
			break;
		case 502:
			type = 'info'
			error.response.message = '网关超时，请检查服务是否正常'
			account.logout();
			location.reload(`/#/login`)
			break;
		default:
			error.response.message = '发生未知错误'
			break;
	}
  if (showMsg) {
    Message({
      message: error.response.message,
      type: type,
      duration: 5 * 1000
    })
  }
	return Promise.reject(error);
});

class APIS {
	constructor() {
		this._initAjax();
		this._init()
	}
	_initAjax() {}
	//初始化
	_init() {
		// this.session = new Session(this); //会话相关
	}
	/**
	 * 获取环境配置信息
	 */
	getEnv() {
		return this.get('/api/env.json').catch(function (err) {
			if (err.response.status == 404) {
				return {
          maintainStatus: false,
          endtime: "2018-11-14 20:00:00",
          isValidate: "true"
        }
			}
		})
	}
	download(url, object) {
		if (object) {
			let token = sessionStorage.publicToken
			object.AccessToken = token;
		}
		let params = Object.keys(object).map(function (key) {
			return encodeURIComponent(key) + "=" + encodeURIComponent((object[key] === null || object[key] === undefined) ? '' : object[key]);
		}).join("&");
		url = this.baseUrl + url + "?1=1&" + params;
		window.open(url);
	}

	/**
	 * 发送Get请求
	 **/
	async get(url, object) {
		return await axios.get(url, {
			params: object
		}).then(function (resp) {
			return resp.data;
		});
	}

	/**
	 * 发送Post请求,具体待调试
	 **/
	async post(url, object) {
		return new Promise((resolve, reject) => {
			axios.post(url, object).then(function (resp) {
				resolve(resp.data);
			}).catch(function (error) {
				//console.log(error)
				reject(error);
			})
		})
	}
}

export default new APIS()



// WEBPACK FOOTER //
// ./src/data/api.js